let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("6jiYX"), load("hAaCB"), load("5A56H"), load("4UPrd"), load("fS7F0")]).then(() => parcelRequire('5WSiB'));